export enum TreeNavKeys {
  Enter = 'Enter',
  Space = ' ',
  ArrowRight = 'ArrowRight',
  ArrowLeft = 'ArrowLeft',
  ArrowDown = 'ArrowDown',
  ArrowUp = 'ArrowUp',
  Home = 'Home',
  End = 'End',
}

/** Node ID of a tree node used by TreeNav. Type created to avoid repeating the
 * type definition in multiple places. */
export type NodeId = number;

/** The minimum required properties (without children) for a node to be used in
 * TreeNav. Child nodes are defined in the TreeNode type. */
interface TreeNodePropertiesWithoutChildren {
  title: string;
  nodeId: NodeId;
  parentNodeId: NodeId | null;
  hasChildren: boolean;
}

/** Original node type passed to TreeNav. It must have the minimal required
 * properties (see TreeNodeProperties), has children for the recursive structure
 * of the navigation tree, and allows additional properties to exist. */
export interface TreeNode extends TreeNodePropertiesWithoutChildren {
  children: TreeNode[] | null;
}

/** The required properties that are added during transformation to a tree node
 * to manage navigation functionality inside TreeNav. Only used internally by
 * TreeNav. */
interface NavigableProperties {
  isExpanded: boolean;
  level: number;
  posInSet: number;
  setSize: number;
  isLoading?: boolean;
}

/** Navigable node type that extends the original node (see TreeNode) with
 * navigable properties. Only used internally by TreeNav. */
export type NavigableTreeNode = TreeNodePropertiesWithoutChildren &
  NavigableProperties & {
    children: NavigableTreeNode[] | null;
  };

/** Callback type for handling node selection. Only used internally by TreeNav. */
export type onSelect = (node: NavigableTreeNode) => void;

/** Callback for loading the children of a node. */
export type onLoadChildren = (nodeId: NodeId) => Promise<TreeNode[]>;
